export const sponsors = [
    { id: 1, name: "MTCX", url: "https://montanacyclocross.com/", logo: "/img/MTCXlogo.png" },
    { id: 2, name: "Red Kite Coaching", url: "https://www.facebook.com/redkitecoaching/", logo: "/img/RedKiteLogo.png" },
    { id: 3, name: "Dram Shop", url: "https://www.dramshopmt.com/", logo: "/img/DramLogo.png" },
    { id: 4, name: "Grist Bakery", url: "https://www.gristmt.com/", logo: "/img/GristLogo.png" },
    { id: 5, name: "VRTX Fitness", url: "https://vrtxfitness.com/", logo: "/img/VRTX_Full_Vertical_Logo_White_Red.png" },
];
